import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './PageStyles.module.css'

export function AuthCallbackPage() {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('Processing authentication...')
  const navigate = useNavigate()

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get OAuth parameters from URL
        const urlParams = new URLSearchParams(window.location.search)
        const oauthToken = urlParams.get('oauth_token')
        const oauthVerifier = urlParams.get('oauth_verifier')
        const denied = urlParams.get('denied')

        if (denied) {
          setStatus('error')
          setMessage('Authorization was denied')
          setTimeout(() => navigate('/'), 3000)
          return
        }

        if (!oauthToken || !oauthVerifier) {
          setStatus('error')
          setMessage('Missing authorization parameters')
          setTimeout(() => navigate('/'), 3000)
          return
        }

        // Exchange for access token
        const response = await fetch(
          `/api/auth/callback?oauth_token=${oauthToken}&oauth_verifier=${oauthVerifier}`
        )

        const data = await response.json()

        if (data.success && data.user) {
          if (window.opener) {
            window.opener.postMessage({ type: 'discogs_auth_success', user: data.user }, '*')
            window.close()
          } else {
            const returnPath = sessionStorage.getItem('discogs_auth_return') || '/settings'
            sessionStorage.removeItem('discogs_auth_return')
            // Notify DiscogsContext — same mechanism as the popup path
            window.postMessage({ type: 'discogs_auth_success', user: data.user }, window.location.origin)
            setStatus('success')
            setMessage('Successfully connected! Redirecting...')
            setTimeout(() => navigate(returnPath), 800)
          }
        } else {
          setStatus('error')
          setMessage(data.message || 'Authentication failed')
          if (window.opener) {
            window.opener.postMessage({ type: 'discogs_auth_error', message: data.message }, '*')
            setTimeout(() => window.close(), 3000)
          } else {
            setTimeout(() => navigate('/settings'), 3000)
          }
        }
      } catch (error) {
        console.error('OAuth callback error:', error)
        setStatus('error')
        setMessage('An error occurred during authentication')
        setTimeout(() => navigate('/'), 3000)
      }
    }

    handleCallback()
  }, [navigate])

  return (
    <div className={styles.page}>
      <div className={styles.centerContent}>
        <div className={styles.authCallback}>
          {status === 'loading' && (
            <>
              <div className={styles.spinner}></div>
              <h2>Authenticating...</h2>
              <p>{message}</p>
            </>
          )}
          {status === 'success' && (
            <>
              <i className="bi bi-check-circle" style={{ fontSize: '48px', color: 'var(--color-success)' }}></i>
              <h2>Success!</h2>
              <p>{message}</p>
            </>
          )}
          {status === 'error' && (
            <>
              <i className="bi bi-x-circle" style={{ fontSize: '48px', color: 'var(--color-error)' }}></i>
              <h2>Error</h2>
              <p>{message}</p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
